import React from 'react';

const Southafrica = () => {
  return (
    <div>
      
    </div>
  );
}

export default Southafrica;
